import { Dialog, Grid, Selector, AutoCenter, Toast, Popup, SearchBar } from 'antd-mobile';
import React, { useEffect, useState, useMemo } from 'react'
import axios from 'axios';
import API_ROUTES from '../../api';
import Icon from '../../icon';
import { useAuth } from '../../app/providers/AuthProvider';

const AddReferee = ({ gameDetail, getGameDetail, getUserListInfo, memberListInfo }) => {

    const { memberInfo } = useAuth();

    const [isAddPopupShow, setIsAddPopupShow] = useState(false)
    const [addSearchKey, setAddSearchKey] = useState('')
    const [totalMemberList, setTotalMemberList] = useState([])
    const [choosePosition, setChoosePosition] = useState([1])

    // Fetch full roster for searching
    useEffect(() => {
        if (isAddPopupShow) {
            getMemberList()
        }
    }, [isAddPopupShow])

    const getMemberList = () => {
        axios.get(API_ROUTES.team_memberList, {
            params: {
                activityId: ""
            }
        })
            .then(function (response) {
                setTotalMemberList(response.data.data || [])
            })
            .catch(function (error) {
                console.error('获取成员列表失败', error);
            })
    }

    // Filter members based on search key
    const filteredMembers = useMemo(() => {
        if (!addSearchKey) return totalMemberList;
        return totalMemberList.filter(m =>
            m.name?.toLowerCase().includes(addSearchKey.toLowerCase())
        );
    }, [totalMemberList, addSearchKey]);

    const getMainImage = (user) => {
        if (!user) return Icon.KEPENG_LOGO;
        const img = user.image || user.memberImage;
        if (img) return img + Icon.ImageFooter;
        const defaultImg = user.memberImageList?.find(item => item.type === 0)?.image;
        if (defaultImg) return defaultImg + Icon.ImageFooter;
        return Icon.KEPENG_LOGO;
    };

    const handleSelectMember = (userId, userName) => {
        const positionLabel = {
            1: "主裁",
            2: "边裁",
            3: "VAR",
            4: "观众"
        }[choosePosition[0]] || "未知位置";

        Dialog.confirm({
            title: '确认添加',
            content: `确定要添加 [${userName}] 为 [${positionLabel}] 吗？`,
            onConfirm: () => {
                Toast.show({
                    icon: 'loading',
                    duration: 0,
                });

                axios.post(API_ROUTES.game_join, {
                    gameId: gameDetail.id,
                    memberId: userId,
                    gameType: choosePosition[0],
                }, {})
                    .then(function (response) {
                        if (response.data.code === 200) {
                            Toast.show({
                                icon: 'success',
                                content: '添加成功！'
                            });
                            setIsAddPopupShow(false);
                            // Refresh all match info
                            if (getGameDetail) getGameDetail();
                            if (getUserListInfo) getUserListInfo();
                        } else {
                            Toast.show({
                                icon: 'fail',
                                content: response.data.msg
                            });
                        }
                    })
                    .catch(function (error) {
                        Toast.show({
                            icon: 'fail',
                            content: '操作失败，请联系管理员！'
                        });
                    });
            }
        });
    }

    const members = memberListInfo || gameDetail?.currentUserInfo || [];

    const refereeInfo = (type, name) => {
        const list = members.filter(item => item.gameType === type)
        if (list && list.length > 0) {
            return list.map(
                user =>
                    <Grid.Item key={user.id || user.memberId}>
                        <div className="mini-player-item">
                            <div className="mini-avatar-wrapper">
                                <img
                                    src={getMainImage(user)}
                                    className="mini-avatar"
                                    style={{ border: '1px solid rgba(22, 93, 255, 0.2)' }}
                                    alt={user.name}
                                />
                            </div>
                            <div className="mini-player-name">{user.name}</div>
                            <div style={{
                                fontSize: '10px',
                                fontWeight: '600',
                                marginTop: '2px',
                                padding: '1px 6px',
                                borderRadius: '6px',
                                display: 'inline-block',
                                color: '#165DFF',
                                background: 'rgba(22, 93, 255, 0.05)',
                                border: '1px solid rgba(22, 93, 255, 0.1)'
                            }}>
                                {name}
                            </div>
                        </div>
                    </Grid.Item>
            )
        }
        return null;
    }

    return (
        <div style={{ padding: '0 8px' }}>
            {memberInfo?.admin === 1 &&
                <button
                    className="premium-btn-base premium-btn-neon-cyan"
                    style={{ width: '100%', marginBottom: '20px' }}
                    onClick={() => setIsAddPopupShow(true)}
                >
                    <span className="premium-btn-icon">⚖️</span> 添加裁判/观众
                </button>
            }

            <div className="member-category-card">
                <div className="member-header-container">
                    <div className="member-category-title" style={{ color: '#165DFF' }}>
                        ⚖️ 裁判与观众
                    </div>
                </div>
                <div className="member-category-content">
                    <Grid columns={5} gap={12}>
                        {refereeInfo(1, "主裁")}
                        {refereeInfo(2, "边裁")}
                        {refereeInfo(3, "VAR")}
                        {refereeInfo(4, "观众")}
                    </Grid>
                </div>
            </div>

            <Popup
                visible={isAddPopupShow}
                onMaskClick={() => setIsAddPopupShow(false)}
                bodyStyle={{ height: '85vh', display: 'flex', flexDirection: 'column', borderTopLeftRadius: '20px', borderTopRightRadius: '20px', overflow: 'hidden' }}
            >
                <div className="captain-popup-header" style={{ padding: '20px', background: '#fff' }}>
                    <div className="captain-popup-title" style={{ fontSize: '18px', fontWeight: '800', color: '#1D2129', marginBottom: '16px' }}>添加裁判/观众</div>

                    <div className="premium-dialog-section-title" style={{ fontSize: '13px', color: '#86909C', marginBottom: '10px' }}>⚖️ 选择位置</div>
                    <Selector
                        className="premium-selector-container"
                        columns={4}
                        options={[
                            { label: "主裁", value: 1 },
                            { label: "边裁", value: 2 },
                            { label: "VAR", value: 3 },
                            { label: "观众", value: 4 },
                        ]}
                        value={choosePosition}
                        onChange={(value) => setChoosePosition(value)}
                    />

                    <div style={{ height: '16px' }}></div>

                    <SearchBar
                        placeholder='输入姓名搜索全员'
                        style={{ '--background': '#f2f3f5', '--border-radius': '10px' }}
                        onChange={val => setAddSearchKey(val)}
                        onClear={() => setAddSearchKey('')}
                    />
                </div>

                <div className="captain-popup-body" style={{ flex: 1, overflowY: 'auto', padding: '0 20px 20px' }}>
                    <div className="member-category-title" style={{ fontSize: '13px', color: '#86909C', margin: '12px 0' }}>
                        共找到 {filteredMembers.length} 名成员
                    </div>
                    {filteredMembers.length > 0 ? (
                        <>
                            {filteredMembers.filter(m => !m.tempMember).length > 0 && (
                                <>
                                    <div style={{ fontSize: '14px', fontWeight: '800', margin: '12px 0 8px', color: '#1D2129' }}>⚽ 科朋队员</div>
                                    <Selector
                                        className="premium-selector"
                                        columns={3}
                                        options={filteredMembers.filter(m => !m.tempMember).map(item => ({
                                            label: item.name,
                                            value: item.id
                                        }))}
                                        onChange={(arr) => {
                                            if (arr.length > 0) {
                                                const selected = totalMemberList.find(m => m.id === arr[0]);
                                                handleSelectMember(selected.id, selected.name);
                                            }
                                        }}
                                    />
                                </>
                            )}

                            {filteredMembers.filter(m => m.tempMember).length > 0 && (
                                <>
                                    <div style={{ fontSize: '14px', fontWeight: '800', margin: '16px 0 8px', color: '#1D2129' }}>👥 临时队员</div>
                                    <Selector
                                        className="premium-selector"
                                        columns={3}
                                        options={filteredMembers.filter(m => m.tempMember).map(item => ({
                                            label: item.name,
                                            value: item.id
                                        }))}
                                        onChange={(arr) => {
                                            if (arr.length > 0) {
                                                const selected = totalMemberList.find(m => m.id === arr[0]);
                                                handleSelectMember(selected.id, selected.name);
                                            }
                                        }}
                                    />
                                </>
                            )}
                        </>
                    ) : (
                        <AutoCenter style={{ marginTop: '40px', color: '#86909C' }}>
                            没有找到匹配的成员
                        </AutoCenter>
                    )}
                </div>
            </Popup>
        </div>
    )
}

export default AddReferee;
